<template>
  <div class="hw-page">
    <navigation />
    <section class="hw-legal-page">
      <article class="hw-article">
        <p class="hw-kicker">Legal</p>
        <h1>Termos e Condições</h1>
        <p>Bem-vindos aos termos e condições do nosso website. Leiam com atenção antes de o utilizar.</p>

        <h2>1. Introdução</h2>
        <p>Estes termos e condições regem a utilização deste website. Ao aceder e utilizar este website, o utilizador concorda em cumpri-los. Se não concordar com algum destes termos, não utilize este website.</p>

        <h2>2. Utilização do website</h2>
        <p>Este website destina-se apenas a fins informativos e promocionais. Qualquer utilização para outros fins é estritamente proibida. O utilizador concorda em usar este website de acordo com todas as leis e regulamentos aplicáveis. É proibida qualquer tentativa de aceder a áreas restritas deste website sem autorização.</p>

        <h2>3. Propriedade intelectual</h2>
        <p>Todo o conteúdo deste website, incluindo textos, imagens, gráficos, logótipos, vídeos e áudios, é propriedade da Hardwired Digital Solutions, Lda ou de terceiros licenciados. Nenhum conteúdo deste website pode ser reproduzido, distribuído, transmitido, exibido, vendido, licenciado ou utilizado de qualquer outra forma sem autorização prévia por escrito da Hardwired Digital Solutions, Lda.</p>

        <h2>4. Ligações para outros websites</h2>
        <p>Este website pode conter ligações para websites de terceiros. Estas ligações são fornecidas apenas para conveniência dos utilizadores. A Hardwired Digital Solutions, Lda não controla e não é responsável pelo conteúdo de websites de terceiros.</p>

        <h2>5. Limitação de responsabilidade</h2>
        <p>A Hardwired Digital Solutions, Lda não será responsável por quaisquer danos diretos, indiretos, incidentais, consequenciais ou especiais resultantes da utilização ou da impossibilidade de utilizar este website, incluindo danos por perda de lucros, interrupção de negócio, perda de informação ou qualquer outro prejuízo financeiro, mesmo que tenha sido avisada da possibilidade de tais danos.</p>

        <h2>6. Alterações aos termos e condições</h2>
        <p>A Hardwired Digital Solutions, Lda reserva-se o direito de modificar estes termos e condições a qualquer momento, sem aviso prévio. Cabe aos utilizadores revê-los periodicamente para ficar a par de quaisquer alterações.</p>

        <h2>7. Jurisdição e lei aplicável</h2>
        <p>Estes termos e condições serão regidos e interpretados de acordo com as leis de Portugal. Qualquer litígio daí decorrente será submetido à jurisdição exclusiva dos tribunais de Portugal.</p>
        <button class="hw-btn hw-btn-ghost" type="button" @click="$router.push('/')">Voltar ao início</button>
      </article>
    </section>
    <bottom />
  </div>
</template>

<script>
import navigation from "../components/Navigation";
import bottom from "../components/Footer";

export default {
  name: "TermsAndConditions",
  components: {
    navigation,
    bottom,
  },
};
</script>
